import { forwardRef } from "react";
import {
  TextField as ReactAriaTextField,
  TextFieldProps as ReactAriaTextFieldProps,
} from "react-aria-components";
import { FieldError } from "react-hook-form";

import type { VariantProps } from "../utils";
import { NcFieldLayout, NcFieldLayoutProps } from "./nc-field-layout";
import { NcInput, ncInputWidthVariants } from "./nc-input";
import { NcLabel } from "./nc-label";

export interface NcTextFieldProps
  extends ReactAriaTextFieldProps,
    VariantProps<typeof ncInputWidthVariants> {
  label: string;
  hideLabel?: boolean;
  description?: string;
  variant?: NcFieldLayoutProps["variant"];
  error?: FieldError;
  placeholder?: string;
}

export const NcTextField = forwardRef<HTMLInputElement, NcTextFieldProps>(
  (
    {
      label,
      hideLabel,
      description,
      isRequired,
      variant,
      error,
      inputWidth = "auto",
      autoComplete,
      ...props
    },
    ref
  ) => (
    <ReactAriaTextField autoComplete={autoComplete} {...props}>
      <NcFieldLayout variant={variant}>
        <NcLabel isRequired={isRequired} hideLabel={hideLabel}>
          {label}
        </NcLabel>
        <NcInput ref={ref} inputWidth={inputWidth} autoComplete={autoComplete} />
        {description && <NcFieldLayout.Description>{description}</NcFieldLayout.Description>}
        <NcFieldLayout.ErrorMessage>{error?.message}</NcFieldLayout.ErrorMessage>
      </NcFieldLayout>
    </ReactAriaTextField>
  )
);
